import React from 'react';
interface Props {
  fillColor?: string;
}
function BloodGlucoseIcon({ fillColor = '#17385D' }: Props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="17"
      viewBox="0 0 12 17"
      fill="none">
      <g clipPath="url(#clip0_851_3589)">
        <path
          d="M6 14.8945C3.51562 14.8945 1.5 12.8789 1.5 10.3945C1.5 9.98828 1.65937 9.34766 2.03125 8.48516C2.39062 7.65391 2.89375 6.74141 3.45312 5.83828C4.35938 4.37578 5.35938 3.01953 6 2.18203C6.64062 3.01641 7.64375 4.37578 8.54688 5.83828C9.10625 6.74141 9.60938 7.65078 9.96875 8.48516C10.3406 9.34766 10.5 9.99141 10.5 10.3945C10.5 12.8789 8.48438 14.8945 6 14.8945ZM0 10.3945C0 13.707 2.6875 16.3945 6 16.3945C9.3125 16.3945 12 13.707 12 10.3945C12 7.54453 7.93125 2.19766 6.79375 0.760156C6.60625 0.525781 6.32812 0.394531 6.02812 0.394531H5.97188C5.67188 0.394531 5.39375 0.525781 5.20625 0.760156C4.06875 2.19766 0 7.54453 0 10.3945ZM4.5 10.1445C4.5 9.72891 4.16563 9.39453 3.75 9.39453C3.33437 9.39453 3 9.72891 3 10.1445C3 11.9383 4.45625 13.3945 6.25 13.3945C6.66563 13.3945 7 13.0602 7 12.6445C7 12.2289 6.66563 11.8945 6.25 11.8945C5.28438 11.8945 4.5 11.1102 4.5 10.1445Z"
          fill={fillColor}
        />
      </g>
      <defs>
        <clipPath id="clip0_851_3589">
          <rect
            width="12"
            height="16"
            fill="white"
            transform="translate(0 0.394531)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export default BloodGlucoseIcon;
